import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {FrameworkModule} from "../framework/framework.module";
import {ApiSharedModule} from "./api.shared.module";
import {
    IntegratedInstanceSearchPageComponent
} from "./integrated-instance/integrated-instance-search-page/integrated-instance-search-page.component";
import {
    IntegratedInstanceSingleSelectControlComponent
} from "./integrated-instance/controls/integrated-instance-single-select-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        ApiSharedModule
    ],
    declarations: [
        IntegratedInstanceSearchPageComponent,
        IntegratedInstanceSingleSelectControlComponent
    ],
    exports: [
        IntegratedInstanceSearchPageComponent,
        IntegratedInstanceSingleSelectControlComponent
    ]
})
export class ApiModule {
}
